var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bet-history-charts" }, [
    _c(
      "div",
      {
        staticClass: "bet-history-charts__bead",
        attrs: { "aria-label": "Result roadmap" },
      },
      [
        _c(
          "div",
          { staticClass: "bet-history-charts__bead-grid" },
          _vm._l(_vm.beadCells, function (cell, index) {
            return _c(
              "div",
              {
                key: `bead-${index}`,
                staticClass: "bet-history-charts__bead-cell",
                class: { "has-result": cell },
                on: {
                  mouseenter: function ($event) {
                    _vm.hoveredIndex = cell ? index : null
                  },
                  mouseleave: function ($event) {
                    _vm.hoveredIndex = null
                  },
                },
              },
              [
                cell
                  ? _c(
                      "span",
                      {
                        staticClass: "bet-history-charts__bead-dot",
                        class: cell.isTai ? "tai" : "xiu",
                      },
                      [_vm._v(" " + _vm._s(cell.value) + " ")]
                    )
                  : _vm._e(),
                cell && _vm.hoveredIndex === index && _vm.hasRound(cell.round)
                  ? _c(
                      "div",
                      {
                        staticClass: "bet-history-charts__tooltip",
                        class: _vm.tooltipPlacement(index),
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "bet-history-charts__tooltip-round" },
                          [_vm._v("#" + _vm._s(cell.round))]
                        ),
                        cell.dice
                          ? _c(
                              "span",
                              {
                                staticClass: "bet-history-charts__tooltip-dice",
                              },
                              _vm._l(cell.dice, function (die, dieIndex) {
                                return _c("img", {
                                  key: dieIndex,
                                  attrs: { src: _vm.diceImage(die), alt: "" },
                                })
                              }),
                              0
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          { staticClass: "bet-history-charts__tooltip-total" },
                          [_vm._v(_vm._s(cell.value))]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "bet-history-charts__log",
        attrs: { "aria-label": "Round history" },
      },
      _vm._l(_vm.roundLogs, function (round, index) {
        return _c(
          "div",
          {
            key: `log-${index}`,
            staticClass: "bet-history-charts__log-row",
            attrs: { title: round ? _vm.roundTitle(round.round) : null },
          },
          [
            !round
              ? _vm._l(5, function (cell) {
                  return _c("span", { key: cell })
                })
              : [
                  _vm._l(round.dice, function (die, dieIndex) {
                    return _c(
                      "span",
                      {
                        key: dieIndex,
                        staticClass: "bet-history-charts__log-die",
                        class: die <= 3 ? "low" : "high",
                      },
                      [_vm._v(" " + _vm._s(die) + " ")]
                    )
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "bet-history-charts__log-total",
                      class: round.isTai ? "tai" : "xiu",
                    },
                    [_vm._v(" " + _vm._s(round.total) + " ")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "bet-history-charts__log-label",
                      class: round.isTai ? "tai" : "xiu",
                    },
                    [_vm._v(" " + _vm._s(round.label) + " ")]
                  ),
                ],
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }